import { sharedConfig } from '@/pageConfig/shared';
import ogImage from '@/static/assets/faq/nl/og.png';
import { Faq } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Faq/faq__nl-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

type FaqItem = { question: string; answer: string };
const faqItems = (content as unknown as { faqItems: FaqItem[] }).faqItems || [];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item: FaqItem) => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer,
    },
  })),
};

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['nl-NL'].layout },
  seo: {
    title: 'Inboedel en aansprakelijkheidsverzekering FAQ • Lemonade Verzekeringen NL',
    metaTitle: 'Inboedel en aansprakelijkheidsverzekering FAQ • Lemonade Verzekeringen NL',
    description:
      'Hier vind je antwoorden op jouw dekkingsvragen - van wat inboedel en aansprakelijkheidsverzekering eigenlijk is, tot wat deze dekt.',
    jsonld: [faqSchema],
    ogImage: ogImage.src,
  },
  MDXContent: content as Faq,
};
